import * as API from 'es6/core/api';
import Localization from 'es6/services/localization';
import SiteController from 'es6/controllers/site-controller';

const ENROLL_SERIES_SELECTOR = '.btn-enroll-series:not(.disabled)';

const GROWL_MESSAGE = Localization.t('growl-message.all-series-courses-focused');

const GROWL_ERROR_MESSAGE = Localization.t('growl-message.all-series-courses-focused-error');

export default class ContentController extends SiteController {
  constructor(store, ...args) {
    super(store, ...args);

    // Enable buttons for courses.
    $('[data-goal-state="unenrolled"][data-series-id]').each((index, el) => {
      const seriesId = $(el).data('series-id');
      $(`.btn-enroll-series[data-series-id=${seriesId}]`).removeClass('disabled');
    });

    $(document).on('click', ENROLL_SERIES_SELECTOR, this._handleEnrollSeries);
  }

  /**
   * Callback for when a series is focused.
   *
   * @this refers to the handle enroll series button
   */
  _handleEnrollSeries(e) {
    // Retrieve the associated series information from the button.
    const button = $(this);
    const seriesId = button.data('series-id');

    // Disable the button to prevent further action.
    button.addClass('disabled');

    /**
     * Get a list of all the goalIds for the series and start updating.
     */
    const requests = $(`[data-goal-state="unenrolled"][data-series-id=${seriesId}]`)
      .map((index, el) => {
        const $el = $(el);
        const goalId = $el.data('goal-id');

        // At the end of each successful request, change the courses state to enrolled.
        return API.postFocusGoal(goalId).then(() => {
          $el.find('.course-state')
            .data('course-state', 'enrolled')
            .removeClass('course-state-unenrolled')
            .addClass('course-state-enrolled');

          return true;
        });
      })

      // Convert to a normal array, as Promise.all does not like jQuery objects.
      .toArray();

    Promise.all(requests)
      .then(resp => $.growl.notice(GROWL_MESSAGE))
      .catch(resp => $.growl.error(GROWL_ERROR_MESSAGE));
  }

  /**
   * Unbind all the enroll events.
   */
  remove() {
    $(document).off('click', ENROLL_SERIES_SELECTOR, this._handleEnrollSeries);
  }
}
